import { createSlice } from '@reduxjs/toolkit';
import {
  FetchIPAWSRequestsAction,
  IPAWSInterface,
  IPAWSRequestsReceivedAction,
  FetchCOGDetailsAction,
  COGDetailsReceivedAction,
  ApproveRequestAction,
  ApproveRequestSuccess,
  DisapproveRequestAction,
  DisapproveRequestSuccess,
  CancelAlertRequestAction,
  CancelAlertRequestSuccess,
  MarkAlertAsReadRequestAction,
  MarkAlertAsReadRequestCompletedAction,
  FetchingIPAWSOptionsDatAction,
  IPAWSOptionsDataReceivedAction,
  UpdateCAPValuesAction,
  UpdateCOGDetailsAction,
  getServiceInfoAction,
  getServiceInfoReceivedAction
} from '../actions/Ipaws';

const initialState: IPAWSInterface = {
  IPAWSRequestsHistoryData: null,
  isFetchingIPAWSRequestsHistoryData: false,
  isApproveRequestSuccess: null,
  cogDetails: null,
  isDisapproveRequestSuccess: false,
  isCancelRequestSuccess: false,
  isFetchingCOGDetails: false,
  isRequestInProgress: false,
  isSubmittingIPAWS: false,
  isMarkAsReadInProgress: false,
  isFetchingIPAWSOptionsData: false,
  IPAWSOptionsData: null,
  isFetchingIPAWSServerInfo: false
};

const IPAWSSlice = createSlice({
  name: 'IPAWS',
  initialState,
  reducers: {
    getIPAWSRequests: (state, _action: FetchIPAWSRequestsAction) => {
      state.isFetchingIPAWSRequestsHistoryData = true;
    },
    IPAWSRequestsReceived: (state, action: IPAWSRequestsReceivedAction) => {
      state.IPAWSRequestsHistoryData = action.payload.IPAWSRequestsHistoryData;
      state.isFetchingIPAWSRequestsHistoryData = false;
    },
    getCOGDetails: (state, _action: FetchCOGDetailsAction) => {
      state.isFetchingCOGDetails = true;
    },
    cogDetailsReceived: (state, action: COGDetailsReceivedAction) => {
      if (action.payload.cogDetails) {
        action.payload.cogDetails.connection_status =
          localStorage.getItem('server_time')?.length &&
          action.payload.cogDetails.connection_status === 'Connected'
            ? 'Connected'
            : 'Disconnected';
      }
      state.cogDetails = action.payload.cogDetails;
      state.isFetchingCOGDetails = false;
    },
    updateCOGDetails: (_state, _action: UpdateCOGDetailsAction) => {},
    requestAlertApprove: (state, _action: ApproveRequestAction) => {
      state.isRequestInProgress = true;
    },
    alertApproveRequestSuccess: (state, action: ApproveRequestSuccess) => {
      state.isRequestInProgress = false;
      state.isApproveRequestSuccess = action.payload.isApproveRequestSuccess;
    },
    requestAlertDisapprove: (state, _action: DisapproveRequestAction) => {
      state.isRequestInProgress = true;
    },
    alertDisapproveRequestSuccess: (
      state,
      action: DisapproveRequestSuccess
    ) => {
      state.isRequestInProgress = false;
      state.isDisapproveRequestSuccess =
        action.payload.isDisapproveRequestSuccess;
    },
    requestCancelAlert: (state, _action: CancelAlertRequestAction) => {
      state.isRequestInProgress = true;
    },
    alertCancelRequestSuccess: (state, action: CancelAlertRequestSuccess) => {
      state.isRequestInProgress = false;
      state.isCancelRequestSuccess = action.payload.isCancelRequestSuccess;
    },
    submittingIPAWS: (state) => {
      state.isSubmittingIPAWS = true;
    },
    submittedIPAWS: (state) => {
      state.isSubmittingIPAWS = false;
    },
    markAlertAsRead: (state, _action: MarkAlertAsReadRequestAction) => {
      state.isMarkAsReadInProgress = true;
    },
    markAlertAsReadCompleted: (
      state,
      _action: MarkAlertAsReadRequestCompletedAction
    ) => {
      state.isMarkAsReadInProgress = false;
    },
    getIPAWSOptionsData: (state, _action: FetchingIPAWSOptionsDatAction) => {
      state.isFetchingIPAWSOptionsData = true;
    },
    IPAWSOptionsDataReceived: (
      state,
      action: IPAWSOptionsDataReceivedAction
    ) => {
      state.IPAWSOptionsData = action.payload.IPAWSOptionsData;
      state.isFetchingIPAWSOptionsData = false;
    },
    updateCAPValues: (_state, _action: UpdateCAPValuesAction) => {},
    getServiceInfo: (state, _action: getServiceInfoAction) => {
      state.isFetchingIPAWSServerInfo = true;
    },
    getServiceInfoReceived: (state, action: getServiceInfoReceivedAction) => {
      if (action.payload.serviceInfo) {
        localStorage.setItem(
          'server_time',
          action.payload.serviceInfo.server_time
        );
      } else if (localStorage.getItem('server_time')) {
        localStorage.removeItem('server_time');
      }
      // Update the connection status based on the server time if cog details is fetched before server info
      // and the server time is available in local storage.
      // This is to ensure that the connection status is updated correctly if the server time is available
      if (state.cogDetails) {
        state.cogDetails.connection_status =
          action.payload.serviceInfo?.server_time?.length &&
          state.cogDetails.connection_status === 'Connected'
            ? 'Connected'
            : 'Disconnected';
      }
      state.isFetchingIPAWSServerInfo = false;
    }
  }
});

export const {
  getIPAWSRequests,
  IPAWSRequestsReceived,
  getCOGDetails,
  cogDetailsReceived,
  updateCOGDetails,
  requestAlertApprove,
  requestAlertDisapprove,
  requestCancelAlert,
  alertCancelRequestSuccess,
  alertDisapproveRequestSuccess,
  alertApproveRequestSuccess,
  submittingIPAWS,
  submittedIPAWS,
  markAlertAsRead,
  markAlertAsReadCompleted,
  getIPAWSOptionsData,
  IPAWSOptionsDataReceived,
  updateCAPValues,
  getServiceInfo,
  getServiceInfoReceived
} = IPAWSSlice.actions;
export default IPAWSSlice.reducer;
